import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagVI = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FCFCFC",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M29.246 17.466a4.246 4.246 0 0 0-8.492 0h-9.341c0 2.308 2.011 4.18 4.32 4.18h-.14a4.18 4.18 0 0 0 4.181 4.18 4.18 4.18 0 0 0 3.407 4.107l-.01.024h3.658l-.01-.024a4.18 4.18 0 0 0 3.406-4.106 4.18 4.18 0 0 0 4.181-4.18h-.14c2.31 0 4.32-1.873 4.32-4.181h-9.34Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m23.134 29.524-2.632 5.944a11.92 11.92 0 0 0 4.499.878c1.592 0 3.11-.314 4.499-.878l-2.633-5.944h-3.733Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M19.566 19.553v7.314c0 4.16 5.435 5.435 5.435 5.435s5.435-1.275 5.435-5.435v-7.314h-10.87Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "m6.063 25.176 2.94 8.221 2.908-8.221h2.22l-4.24 10.87H8.114l-4.272-10.87h2.22ZM40.22 36.045V25.176h2.112v10.87h-2.113Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M21.738 21.915v8.863c.747.55 1.551.928 2.174 1.17V21.916h-2.174ZM28.259 21.915v8.863a9.569 9.569 0 0 1-2.174 1.17V21.916h2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M19.566 19.553h10.87v3.449h-10.87v-3.449Z"
}));
FlagVI.displayName = 'FlagVI';
export default withFlagWrapper(FlagVI);
//# sourceMappingURL=index.js.map